import { User } from '../../shared/models';
import { ChatMessage } from '../models';
import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'chat-message',
    template: require('./chat-message.component.pug'),
    styles: [require('./chat-message.component.scss')]
})
export class ChatMessageComponent implements OnInit {
@Input() message: ChatMessage;
@Input() user: User;

    incoming: Boolean;

    ngOnInit() {
        this.incoming = this.message.name !== this.user.name;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/chat/chat-message/chat-message.component.ts